<div *ngIf="showGroupHeader" class="performance-group-header">
  <!-- Show Performance  label -->
  <div
    *ngIf="performanceTypeToggle?.length > 1"
    class="performance-group-header__show-performance-lbl"
  >
    {{ "products.show-performance" | translate }}
  </div>

  <!-- Performance Type: Toggle -->
  <div
    *ngIf="performanceTypeToggle?.length > 1"
    class="performance-group-header__performance-type-toggle"
  >
    <eds-toggle
      [toggleButtons]="performanceTypeToggle"
      (toggleActive)="onPerformanceTypeUpdate($event)"
    ></eds-toggle>
  </div>

  <!-- Performance Type label -->
  <div class="performance-group-header__performance-type-lbl">
    <span
      *ngIf="
        (isHandheld$ | async) !== true &&
        performanceViewOptions?.length === 1 &&
        isSiteIntl
      "
    >
      {{ performanceViewOptions[0].headerLabelKey | translate }}
    </span>
    <span
      *ngIf="
        (isHandheld$ | async) !== true &&
        performanceViewOptions?.length === 1 &&
        !isSiteIntl
      "
      >{{ selectedPerfTypeHeaderKey$ | async | translate }}
      <eds-footnote
        [placement]="placement"
        [ariaLabel]="'products.footnotes-title' | translate"
      ></eds-footnote
    ></span>
    <span class="performance-group-header__as-of-date-lbl text-grey1"
      >{{ "pds.PERF_AS_OF_DATE" | translate }}
      {{ performanceAsOf$ | async }}</span
    >
  </div>

  <!-- Performance End: Toggle -->
  <div
    *ngIf="periodEndToggle?.length > 1"
    class="performance-group-header__period-end-toggle"
  >
    <eds-toggle
      [toggleButtons]="periodEndToggle"
      (toggleActive)="onPeriodEndUpdate($event)"
    ></eds-toggle>
  </div>

  <!-- Currency: Dropdown -->
  <div
    *ngIf="showPerformanceCurrencyDropdown"
    class="performance-group-header__performance-currency"
  >
    <eds-dropdown
      [dropdownId]="'performance-currency-dropdown'"
      [name]="'performance-currency-dropdown'"
      [label]="'products.ppss-performance-currency-label' | translate"
      [titleText]="'products.ppss-filter-select' | translate"
      [items]="performanceCurrencyOptions"
      [preselectedValue]="selectedPerformanceCurrencyOption"
      (dropdownChange)="onPerformanceCurrencyUpdate($event)"
      theme="ag-grid"
    >
    </eds-dropdown>
  </div>
</div>
